module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_02 (2).28a85842.png";